import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {SLICE_BASE_NAME} from './constants'
import config from "@/constants/app.constant";

export type ConstantsState = Record<string, any>

const initialState: ConstantsState = {
    ...config,
}

const constantsSlice = createSlice({
    name: `${SLICE_BASE_NAME}/constants`,
    initialState,
    reducers: {
        setConstants(state, action: PayloadAction<ConstantsState>) {
            for (const key in action.payload)
                state[key] = action.payload[key];
        },
    },
})

export const {
    setConstants,
} = constantsSlice.actions
export default constantsSlice.reducer
